/**
 * HeadingKeys - adds `dataKey` (and `dataLabel`) global attributes to heading AND paragraph nodes
 * (rendered as `data-key` / `data-label`). Hosts that project a STRUCTURED model into a Tiptap doc
 * (the deal Scope doc: H1 section / H2 group or scope item / H3 question) stamp each heading with its
 * model key, so the harvest-on-save can anchor edits to model entities exactly instead of matching
 * heading text/slugs (labels repeat; text can be edited). Paragraph stamps anchor STRUCTURED rows the
 * same way (`brief:<dim>` scope-brief rows, `chips:*` display-only chip rows), so a row keeps its
 * meaning even when the user mangles its visible label. `dataLabel` carries a row's FIXED key label
 * (e.g. a scope-brief dimension name) which the host renders as a non-editable CSS `::before` - so the
 * label is a predefined key, not editable content, and never lands in the harvested value. Nodes the
 * USER adds have dataKey null - that is the "new content" signal. Inert for docs that never set them
 * (SOW etc.): the attributes default to null and render nothing.
 */
import { Extension } from '@tiptap/core';
export const HeadingKeys = Extension.create({
    name: 'headingKeys',
    addGlobalAttributes() {
        return [
            {
                types: ['heading', 'paragraph'],
                attributes: {
                    dataKey: {
                        default: null,
                        parseHTML: (el) => el.getAttribute('data-key'),
                        renderHTML: (attrs) => attrs.dataKey ? { 'data-key': String(attrs.dataKey) } : {},
                    },
                    dataLabel: {
                        default: null,
                        parseHTML: (el) => el.getAttribute('data-label'),
                        renderHTML: (attrs) => attrs.dataLabel ? { 'data-label': String(attrs.dataLabel) } : {},
                    },
                    // A row's display STATUS (e.g. a scope item's scopeStatus) rendered as `data-status`, so the
                    // host can style it (a deferred/context scope item strikes its heading through, matching the
                    // questionnaire). Presentational only - the model value lives in scope_meta, not the doc.
                    dataStatus: {
                        default: null,
                        parseHTML: (el) => el.getAttribute('data-status'),
                        renderHTML: (attrs) => attrs.dataStatus ? { 'data-status': String(attrs.dataStatus) } : {},
                    },
                },
            },
        ];
    },
});
//# sourceMappingURL=headingKeys.js.map